module.exports = __webpack_public_path__ + "static/media/gl.841a9d98.svg";